import { assetEditService } from "api/assetEditService";

export const assetDetailAction = {
  getAssetDetails
};


async function getAssetDetails(id: string) {
  try {
    const response = await assetEditService.getAssetDetails(id).then((result: any) => result.json());
    return response;
  }
  catch (error) {
    return {
      message: error?.toString()
    };
  }

}
